export const ONE_WAY = [
  'token-hashing', 'multi-cluster-management'
];
